import { Dispatch, SetStateAction } from 'react';

import { InsightType } from 'lib/apis/entity/insight';
import { useOwnTranslate } from 'lib/hooks/useOwnTranslate';

type Props = {
  mode: InsightType.TrendMode;
  setMode: Dispatch<SetStateAction<InsightType.TrendMode>>;
};

const TrendTypes: InsightType.TrendMode[] = ['RAW', 'PERCENTAGE'];

const HousePricesTrendsType = ({ mode, setMode }: Props) => {
  const { t } = useOwnTranslate('hpi.trends');
  return (
    <>
      <div className="flex flex-row items-center gap-4">
        {TrendTypes.map((trendTypeKey) => (
          <label
            key={trendTypeKey}
            className="flex flex-row items-center gap-[6px] text-xs cursor-pointer"
            htmlFor={trendTypeKey}
          >
            <span>{t(trendTypeKey.toString().toLowerCase())}</span>
            <input
              id={trendTypeKey}
              name="trendType"
              type="radio"
              value={trendTypeKey}
              checked={mode === trendTypeKey}
              onChange={() => setMode(trendTypeKey)}
            />
          </label>
        ))}
      </div>
    </>
  );
};

export default HousePricesTrendsType;
